import { Model } from '@vuex-orm/core'
import { WebhookDto } from './webhook.interface'
import { Constants } from '@/constants'

export default class Webhook extends Model {
    static entity = 'webhooks'

    static fields() {
        return {
            id: this.attr(null),
            email: this.attr(''),
            name: this.attr('')
        }
    }

    static async createOne(payload: WebhookDto) {
        return await this.api().post(Constants.API.WEBHOOK, payload)
    }

    static async findOne(id: number) {
        return await this.api().get(Constants.API.WEBHOOK + "/" + id)
    }

    static async updateOne(id: number, payload: WebhookDto) {
        return await this.api().patch(Constants.API.WEBHOOK + "/" + id, payload)
    }

    static async removeOne(id: number) {
        return await this.api().delete(Constants.API.WEBHOOK + "/" + id)
    }

    static apiConfig = {
        actions: {
            fetch: {
                method: 'get',
                url: '/webhooks'
            }
        }
    }
}
